import { normalizeAutocompleteText } from "src/v2/utils/autocomplete/filter-autocomplete-options"

export const filterDataLakeCompanies = (companies) => (Array.isArray(companies) ? companies : [])
    .filter((company) => normalizeAutocompleteText(company?.Setor) !== "consorcio")
